import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-view-beneficiary',
  templateUrl: './view-beneficiary.component.html',
  styleUrls: ['./view-beneficiary.component.scss'],
})
export class ViewBeneficiaryComponent implements OnInit {
  viewBeneficiaryList = [];
  claimID;
  policyNumber;
  dropdownList: any;
  isLoading: boolean = false;

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<ViewBeneficiaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  async ngOnInit() {
    this.isLoading = true;
    this.policyNumber = this.data.itemData.policyNumber;
    this.claimID = this.data.claimID;
    this.dropdownList = this.commonService.lazyList;
    await this.getExistingPolicy();
    this.isLoading = false;
  }

  async getExistingPolicy() {
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimID +
        '/existingPolicies';
      let getExistingPolicies = await this.commonService.commonGet(url);
      for (const item of getExistingPolicies.body._links.item) {
        if(item.summary.policyNumber == this.policyNumber){
          await this.getBeneficiaryDetails(item.summary.uuid);
          break;
        }
      }
    } catch (err) {
      console.log('Get API Error - Getting View beneficiary Data Error.', err);
    }
  }

  //Get API - Getting View beneficiary Data.
  async getBeneficiaryDetails(uuid) {
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimID +
        '/policy/' +
        uuid +
        '/beneficiaries';
      let response = await this.commonService.commonGet(url);
      this.viewBeneficiaryList = response.body._links.item;
    } catch (err) {
      console.log('Get API Error - Getting View beneficiary Data Error.', err);
    }
  }
  getLabelDropdown(dropdownName, value){
    let label = '';
    try {
      let dropdownlabel = this.dropdownList[dropdownName].filter(data => data.value == value);
      if(dropdownlabel) {
        label = dropdownlabel[0].label;
      }  
    } catch (error) {
      console.log(error);
    }
    return label;
  }

  onOk() {
    this.dialogRef.close();
  }
  dateFormeting(value){
    return this.commonService.formetdateGetingfromAPI(value)
  }
}
